import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.scss'
import { getPublicBranding } from './api'

Vue.use(ElementUI, { size: 'medium' })
Vue.config.productionTip = false

// 未登录时拉平台品牌；已登录用 userInfo 里的租户品牌，避免刷新串单位
if (!store.state.token) {
  getPublicBranding()
    .then(res => {
      if (res && res.data) store.commit('SET_BRANDING', res.data)
    })
    .catch(() => {})
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
